var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NumberInput, UnControlledFormField } from '../../common';
import { CopyFromLocationDropdown } from '../common/CopyFromLocationDropdown';
import { StaffSettingsSection, WorkHoursFields } from './WorkHoursFields';
export var mapStaffSettingsFieldChange = function (field, value) {
  return function (f) {
    var _a;
    return __assign(__assign({}, f), (_a = {}, _a[field] = value, _a.isDirty = true, _a));
  };
};
export var StaffSettingsFormContent = function (_a) {
  var form = _a.form,
    onChange = _a.onChange,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffSettings'
  }).t;
  var handleFieldChange = function (field, value) {
    onChange(mapStaffSettingsFieldChange(field, value));
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Stack, __assign({
      direction: "row",
      spacing: 3,
      sx: {
        mb: 3
      },
      flexWrap: "wrap",
      useFlexGap: true
    }, {
      children: [_jsx(StaffSettingsSection, __assign({
        title: t('agentAttrition', {
          defaultValue: 'Agent Attrition'
        }),
        sx: {
          flex: 1,
          minWidth: 280,
          mb: 0
        }
      }, {
        children: _jsxs(Stack, __assign({
          direction: "row",
          spacing: 3,
          flexWrap: "wrap",
          useFlexGap: true
        }, {
          children: [_jsx(UnControlledFormField, __assign({
            label: t('avgWeeklyAttrition', {
              defaultValue: 'Average weekly attrition'
            }),
            unitLabel: "%",
            sx: {
              flex: 1,
              minWidth: 150
            }
          }, {
            children: _jsx(NumberInput, {
              min: 0,
              max: 100,
              decimal: 2,
              value: form.avgWeeklyAttrition,
              disabled: disabled,
              onChange: function (v) {
                return handleFieldChange('avgWeeklyAttrition', v == null ? '' : String(v));
              }
            })
          })), _jsx(UnControlledFormField, __assign({
            label: t('avgMonthlyAttrition', {
              defaultValue: 'Average monthly attrition'
            }),
            unitLabel: "%",
            sx: {
              flex: 1,
              minWidth: 150
            }
          }, {
            children: _jsx(NumberInput, {
              min: 0,
              max: 100,
              decimal: 2,
              value: form.avgMonthlyAttrition,
              disabled: disabled,
              onChange: function (v) {
                return handleFieldChange('avgMonthlyAttrition', v == null ? '' : String(v));
              }
            })
          }))]
        }))
      })), _jsx(StaffSettingsSection, __assign({
        title: t('agentRecruitment', {
          defaultValue: 'Agent Recruitment/Training'
        }),
        sx: {
          flex: 1,
          minWidth: 280,
          mb: 0
        }
      }, {
        children: _jsxs(Stack, __assign({
          direction: "row",
          flexWrap: "wrap",
          useFlexGap: true,
          justifyContent: "center",
          spacing: 3
        }, {
          children: [_jsx(UnControlledFormField, __assign({
            label: t('graduationRate', {
              defaultValue: 'Graduation rate'
            }),
            unitLabel: "%",
            sx: {
              flex: 1,
              minWidth: 150
            }
          }, {
            children: _jsx(NumberInput, {
              min: 1,
              max: 100,
              decimal: 2,
              value: form.graduationRate,
              disabled: disabled,
              onChange: function (v) {
                return handleFieldChange('graduationRate', v == null ? '' : String(v));
              }
            })
          })), _jsx(UnControlledFormField, __assign({
            label: t('classSize', {
              defaultValue: 'Class size'
            }),
            sx: {
              flex: 1,
              minWidth: 150
            }
          }, {
            children: _jsx(NumberInput, {
              min: 1,
              max: 10000,
              decimal: 0,
              value: form.classSize,
              disabled: disabled,
              onChange: function (v) {
                return handleFieldChange('classSize', v == null ? '' : String(v));
              }
            })
          })), _jsx(UnControlledFormField, __assign({
            label: t('recruitingLeadTime', {
              defaultValue: 'Recruiting lead time'
            }),
            unitLabel: t('recruitingLeadTimeUnit', {
              defaultValue: 'WKS'
            }),
            sx: {
              flex: 1,
              minWidth: 150
            }
          }, {
            children: _jsx(NumberInput, {
              min: 1,
              max: 52,
              decimal: 0,
              value: form.recruitingLeadTimeWeeks,
              disabled: disabled,
              onChange: function (v) {
                return handleFieldChange('recruitingLeadTimeWeeks', v == null ? '' : String(v));
              }
            })
          }))]
        }))
      }))]
    })), _jsx(StaffSettingsSection, __assign({
      title: t('agentWorkHours', {
        defaultValue: 'Agents: Day/Hours of Work'
      })
    }, {
      children: _jsx(WorkHoursFields, {
        value: form.agent,
        disabled: disabled,
        onChange: function (updater) {
          return onChange(function (f) {
            return __assign(__assign({}, f), {
              agent: updater(f.agent),
              isDirty: true
            });
          });
        }
      })
    })), _jsx(StaffSettingsSection, __assign({
      title: t('supportWorkHours', {
        defaultValue: 'Support Staff: Days/Hours of Work'
      })
    }, {
      children: _jsx(WorkHoursFields, {
        value: form.support,
        disabled: disabled,
        onChange: function (updater) {
          return onChange(function (f) {
            return __assign(__assign({}, f), {
              support: updater(f.support),
              isDirty: true
            });
          });
        }
      })
    }))]
  });
};
export var StaffSettingsLocationConfigPanel = function (_a) {
  var form = _a.form,
    locationId = _a.locationId,
    allLocations = _a.allLocations,
    onChange = _a.onChange,
    onCopyFrom = _a.onCopyFrom,
    onClear = _a.onClear,
    _b = _a.isCopying,
    isCopying = _b === void 0 ? false : _b,
    copyDropdownKey = _a.copyDropdownKey,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffSettings'
  }).t;
  return _jsxs(Box, __assign({
    sx: {
      '& .MuiInputLabel-root': {
        fontSize: function (theme) {
          return theme.typography.body2.fontSize;
        }
      }
    }
  }, {
    children: [_jsxs(Stack, __assign({
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      sx: {
        mb: 3
      },
      flexWrap: "wrap",
      useFlexGap: true
    }, {
      children: [_jsx(Typography, __assign({
        variant: "h3"
      }, {
        children: t('title', {
          defaultValue: 'Staff Settings'
        })
      })), _jsx(CopyFromLocationDropdown, {
        locations: allLocations,
        currentLocationId: locationId,
        onCopy: onCopyFrom,
        onClear: onClear,
        disabled: disabled || isCopying
      }, copyDropdownKey)]
    })), _jsx(StaffSettingsFormContent, {
      form: form,
      onChange: onChange,
      disabled: disabled
    })]
  }));
};